import { render, staticRenderFns } from "./_UploadImageToGallery.vue?vue&type=template&id=22d358c1&"
import script from "./_UploadImageToGallery.vue?vue&type=script&lang=js&"
export * from "./_UploadImageToGallery.vue?vue&type=script&lang=js&"
import style0 from "./_UploadImageToGallery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports